import PropTypes from 'prop-types';
import React from 'react';

import { Container, Tab } from './styledComponents';

/**
 * Status tabs of the external orders list, displayed right under the breadcrumb. They are a plain
 * narrowing of the list — not a navigation — so they hold no route of their own.
 */
const StatusTabs = ({ tabs, selectedTabKey, onSelectTab }) => (
  <Container>
    {tabs.map(({ key, name }) => (
      <Tab
        isSelected={key === selectedTabKey}
        key={key}
        onClick={() => {
          onSelectTab(key);
        }}
      >
        {name}
      </Tab>
    ))}
  </Container>
);

StatusTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedTabKey: PropTypes.string.isRequired,
  onSelectTab: PropTypes.func.isRequired,
};

export default StatusTabs;
